
import { getParameterDefinitions } from '../../core';

import ParameterGeomPolygon from './ParameterGeomPolygon';

export default function getParameterDefinitionsWithGeom() {
    let paramDefinitions = {
        ...getParameterDefinitions(),
        'GeomPolygon': {
            component: ParameterGeomPolygon,
            props: ['generatePolygonDefinition', 'id', 'tempFeature', 'title', 'onChangeValue', 'onSetGeometry']
        },
    };

    return paramDefinitions;
}